import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomTable from "global/components/CustomTable/CustomTable";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { fetchDocumentsByMonths } from "./RenewableFunction";
import { useLocation } from "react-router-dom";
import moment from "moment";
import history from "utils/history";
import { RENEWABLE_CONSTANTS } from "./RenewableConstants";
import title from "global/constants/TitleConstants";
import { focusRing } from "theme/colors";
import { useTitle } from "utils/UseTitle";

// Page-scoped so the back button and the shared table's pagination controls
// get the brand focus ring without restyling those components app-wide.
const pageFocusRingSx = {
  "& .MuiIconButton-root:focus-visible, & .MuiPaginationItem-root:focus-visible":
    {
      outline: `2px solid ${focusRing}`,
      outlineOffset: "2px",
    },
};

const RenewableDocumentsList = () => {
  useTitle(title.RENEWABLE_DOCUMENTS_LIST);
  const location = useLocation<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState<any[]>([]);
  const dateFromState = location.state?.date;

  useEffect(() => {
    if (dateFromState) {
      fetchDocumentsByMonths(dateFromState, setIsLoading, setRows);
    }
  }, [dateFromState]);

  return (
    <CenteredAuthenticatedLayout>
      <Box sx={pageFocusRingSx}>
        <Stack direction={"row"} alignItems={"center"} spacing={2} mb={3}>
          <Tooltip title="Go back">
            <IconButton aria-label="Go back" onClick={() => history.goBack()}>
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
          <Typography
            id="renewable-documents-list-heading"
            component="h1"
            variant="body1"
            color="text.primary"
            fontWeight={700}
          >
            Documents needed to be renewed in{" "}
            {moment(dateFromState).format("MMMM, YYYY")}
          </Typography>
        </Stack>
        <CustomTable
          emptyState={{
            icon: "doc",
            title: "No documents due for renewal",
            body: "Documents with a renewal date in the selected range are listed here.",
          }}
          ariaLabelledBy="renewable-documents-list-heading"
          headers={RENEWABLE_CONSTANTS.TABLE_HEADERS}
          rows={rows}
          isLoading={isLoading}
          count={rows.length}
          showPagination={true}
          rowsPerPage={10}
          page={1}
          variant="primary"
        />
      </Box>
    </CenteredAuthenticatedLayout>
  );
};

export default RenewableDocumentsList;
